import { ThemeAnchor } from '@/components/ThemeButton/ThemeAnchor.js';
import { ThemeButton } from '@/components/ThemeButton/ThemeButton.js';
import {
  Background,
  HoverText,
  Text,
} from '@/components/ThemeButton/ThemeButton.styles.js';
import { styled } from '@/stitches/index.js';
import { isTheme } from '@/stitches/isTheme.js';
import * as sydney from '@/templates/sydney/themes/index.js';
import { type CSS } from '@stitches/react';

const ButtonStyles: CSS & {
  variants: {
    variant: {
      inverted: CSS;
    };
  };
} = {
  '@bp0': {
    fontSize: '$14',
  },
  '@bp2': {
    fontSize: '$16',
  },
  variants: {
    variant: {
      inverted: {
        backgroundColor: '$defaultFont',
        color: '$pageBackground',
        [`${Background}`]: {
          backgroundColor: '$pageBackground',
        },
        [`${HoverText}`]: {
          color: '$defaultFont',
        },
        [isTheme([sydney.midnight])]: {
          [`${Text}`]: {
            color: '$defaultFont',
          },
          '&:hover': {
            borderColor: '$secondaryFont',
            color: '$defaultFont',
          },
          backgroundColor: '$secondaryFont',
          borderColor: '$secondaryFont',
          color: '$defaultFont',
        },
      },
    },
  },
};

export const Button = styled(ThemeButton, ButtonStyles);

export const Anchor = styled(ThemeAnchor, ButtonStyles);
